import { Course } from '../../types';
import { dspyModule1 } from '../modules/dspyModule1';
import { dspyModule2 } from '../modules/dspyModule2';
// Modules 3-9 are currently under development - included for display but disabled for interaction
import { dspyModule3 } from '../modules/dspyModule3';
import { dspyModule4 } from '../modules/dspyModule4';
import { dspyModule5 } from '../modules/dspyModule5';
import { dspyModule6 } from '../modules/dspyModule6';
import { dspyModule7 } from '../modules/dspyModule7';
import { dspyModule8 } from '../modules/dspyModule8';
import { dspyModule9 } from '../modules/dspyModule9';

export const dspyCourse: Course = {
  id: 'dspy-mastery',
  title: 'DSPy Fundamentals: Core Concepts and Modules',
  description:
    'Learn the fundamentals of DSPy (Declarative Self-improving Python) framework. Master core concepts, signatures, and essential modules like Predict, ChainOfThought, ProgramOfThought, and ReAct for building structured AI programs.',
  category: 'ai-programming',
  difficulty: 'intermediate',
  estimatedHours: 12,
  prerequisites: ['python-programming', 'machine-learning-basics', 'language-models'],
  tags: [
    'dspy',
    'language-models',
    'ai-programming',
    'optimization',
    'nlp',
    'python',
    'machine-learning',
    'production-ai',
  ],
  thumbnail: '/images/dspy-course.png',
  modules: [
    dspyModule1,
    dspyModule2,
    dspyModule3,
    // Modules 4-9 are under development - included for display but disabled for interaction
    dspyModule4,
    dspyModule5,
    dspyModule6,
    dspyModule7,
    dspyModule8,
    dspyModule9,
  ],
  tools: {
    reference: true,
    codeRunner: true,
  },
};
